// extracted by mini-css-extract-plugin
module.exports = {"home":"HomePage_home__buMPF"};